import styled from '@emotion/styled';
import { mediaQueries, remCalc, font, componentReset } from '../../css';

const StyledFooter = styled('footer')(({ theme }) => ({
    ...componentReset,

    padding: remCalc(0, 15),
    fontFamily: font.family.body,
    [mediaQueries.medium]: {
        padding: remCalc(0, 50),
    },
    backgroundColor: theme.global.navBgColor,
}));

export { StyledFooter };
